module.exports = __webpack_public_path__ + "img/delivery-truck.594712c6.svg";